import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { LifeBuoy, Send, Mail } from "lucide-react";

export function ContactModal({ open, onOpenChange }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!form.name.trim() || !form.message.trim()) { toast.error("Nom et message requis"); return; }
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé à la Direction ✅");
      setForm({ name: "", phone: "", email: "", message: "" });
      onOpenChange(false);
    } catch (e) { toast.error(apiError(e)); }
    finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="contact-modal" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><LifeBuoy className="w-5 h-5 text-[#F26419]" /> Contact support</DialogTitle>
          <DialogDescription className="sr-only">Formulaire de contact — votre message arrive dans l'Espace Direction.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-[#75807A] flex items-center gap-1.5 -mt-2"><Mail className="w-4 h-4" /> contact@bentskingo.com</p>
        <div className="space-y-3 mt-1">
          <Input data-testid="contact-name" placeholder="Votre nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <Input data-testid="contact-phone" placeholder="Téléphone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          <Input data-testid="contact-email" placeholder="Email (facultatif)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <textarea data-testid="contact-message" rows={5} placeholder="Votre message…" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full rounded-xl border-2 border-[#E2DFD8] px-4 py-3 focus:outline-none focus:border-[#F26419]" />
          <Button data-testid="contact-send" onClick={submit} disabled={sending} className="w-full gap-2 bg-[#F26419] hover:bg-[#D85312] text-white">
            <Send className="w-4 h-4" /> {sending ? "Envoi…" : "Envoyer à la Direction"}
          </Button>
          <p className="text-xs text-[#75807A] text-center">Votre message arrive directement dans l'Espace Direction.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
